import { Helmet } from 'react-helmet-async'

interface SEOMetaProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: string
  locale?: string
}

export const SEOMeta: React.FC<SEOMetaProps> = ({
  title = process.env.REACT_APP_GAME_NAME,
  description = process.env.REACT_APP_GAME_DESCRIPTION,
  image = `${process.env.PUBLIC_URL}/kotobade-asobou_card_600x314.png`,
  url = process.env.REACT_APP_GAME_LINK,
  type = 'website',
  locale = 'ja_JP',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={locale} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}
